module.exports = __webpack_public_path__ + "static/media/max-k-12.d3db1ab2.png";